import React, { useEffect, useState } from 'react';
import Layout from '../../components/shared/Layout';
import api from '../../utils/api';

const TwoFA = () => {
  const [status, setStatus] = useState(null);
  const [qr, setQr] = useState('');
  const [secret, setSecret] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ text: '', ok: true });
  const [step, setStep] = useState('idle'); // idle | setup | verify

  const loadStatus = () => api.get('/2fa/status').then(r => setStatus(r.data)).catch(() => {});

  useEffect(() => { loadStatus(); }, []);

  const showMsg = (text, ok = true) => { setMsg({ text, ok }); setTimeout(() => setMsg({ text: '', ok: true }), 4000); };

  const handleSetup = async () => {
    setLoading(true);
    try {
      const r = await api.post('/2fa/setup');
      setQr(r.data.qr);
      setSecret(r.data.secret);
      setStep('verify');
    } catch (e) {
      showMsg(e.response?.data?.error || 'QR oluşturulamadı', false);
    } finally { setLoading(false); }
  };

  const handleVerify = async () => {
    if (token.length !== 6) return showMsg('6 haneli kod girin', false);
    setLoading(true);
    try {
      await api.post('/2fa/verify', { token });
      showMsg('2FA başarıyla etkinleştirildi!');
      setStep('idle');
      setToken('');
      loadStatus();
    } catch (e) {
      showMsg(e.response?.data?.error || 'Kod hatalı', false);
    } finally { setLoading(false); }
  };

  const handleDisable = async () => {
    if (!window.confirm('2FA\'yı devre dışı bırakmak istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      await api.delete('/2fa/disable');
      showMsg('2FA devre dışı bırakıldı');
      loadStatus();
    } catch (e) {
      showMsg(e.response?.data?.error || 'İşlem başarısız', false);
    } finally { setLoading(false); }
  };

  const cardStyle = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 28, marginBottom: 20 };

  return (
    <Layout>
      <div style={{ maxWidth: 520 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827', marginBottom: 4 }}>İki Faktörlü Doğrulama</h1>
        <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 28 }}>
          Hesabınızı ekstra güvenlik katmanıyla koruyun.
        </p>

        {msg.text && (
          <div style={{ padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14,
            background: msg.ok ? '#f0fdf4' : '#fef2f2', color: msg.ok ? '#16a34a' : '#dc2626' }}>
            {msg.text}
          </div>
        )}

        {/* Durum kartı */}
        <div style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 16, color: '#111827' }}>2FA Durumu</div>
              <div style={{ marginTop: 4, fontSize: 13, color: '#6b7280' }}>
                Google Authenticator, Authy veya benzeri bir uygulama kullanın.
              </div>
            </div>
            <span style={{
              padding: '5px 14px', borderRadius: 20, fontSize: 13, fontWeight: 600,
              background: status?.enabled ? '#dcfce7' : '#f3f4f6',
              color: status?.enabled ? '#16a34a' : '#6b7280'
            }}>
              {status === null ? '...' : status?.enabled ? 'Aktif' : 'Pasif'}
            </span>
          </div>

          <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
            {!status?.enabled ? (
              <button onClick={() => step === 'idle' ? handleSetup() : setStep('idle')} disabled={loading} style={{
                padding: '10px 20px', background: '#2563eb', color: '#fff',
                border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer'
              }}>
                {loading && step === 'idle' ? 'QR Oluşturuluyor...' : '2FA\'yı Etkinleştir'}
              </button>
            ) : (
              <button onClick={handleDisable} disabled={loading} style={{
                padding: '10px 20px', background: '#fff', color: '#dc2626',
                border: '1px solid #fca5a5', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer'
              }}>
                {loading ? 'İşleniyor...' : 'Devre Dışı Bırak'}
              </button>
            )}
          </div>
        </div>

        {/* QR & Doğrulama adımı */}
        {step === 'verify' && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: 16, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
              Authenticator Uygulamasıyla Tarayın
            </h2>

            {qr && (
              <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <img src={qr} alt="QR Code" style={{ width: 180, height: 180, border: '1px solid #e5e7eb', borderRadius: 8 }} />
              </div>
            )}

            {secret && (
              <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 14px', marginBottom: 20 }}>
                <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Manuel giriş kodu:</div>
                <code style={{ fontSize: 14, fontFamily: 'monospace', color: '#111827', letterSpacing: 2 }}>
                  {secret.match(/.{1,4}/g)?.join(' ')}
                </code>
              </div>
            )}

            <ol style={{ fontSize: 13, color: '#6b7280', paddingLeft: 20, marginBottom: 20, lineHeight: 1.8 }}>
              <li>Google Authenticator veya Authy uygulamasını açın</li>
              <li>Yeni hesap ekle → QR kodu tara</li>
              <li>Uygulama size 6 haneli kod gösterecek</li>
              <li>Kodu aşağıya girin ve doğrulayın</li>
            </ol>

            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 8 }}>
              Doğrulama Kodu
            </label>
            <input
              type="text" maxLength={6} value={token}
              onChange={e => setToken(e.target.value.replace(/\D/g, ''))}
              placeholder="000000"
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 20, letterSpacing: 8, textAlign: 'center', boxSizing: 'border-box', marginBottom: 16 }}
            />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleVerify} disabled={loading || token.length !== 6} style={{
                flex: 1, padding: '11px 0', background: token.length === 6 ? '#2563eb' : '#93c5fd',
                color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: token.length === 6 ? 'pointer' : 'not-allowed'
              }}>
                {loading ? 'Doğrulanıyor...' : 'Doğrula ve Etkinleştir'}
              </button>
              <button onClick={() => { setStep('idle'); setQr(''); setSecret(''); setToken(''); }} style={{
                padding: '11px 16px', background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, cursor: 'pointer'
              }}>İptal</button>
            </div>
          </div>
        )}

        {/* Bilgi kutusu */}
        <div style={{ background: '#fffbeb', border: '1px solid #fde047', borderRadius: 10, padding: '14px 18px', fontSize: 13, color: '#92400e' }}>
          <strong>Önemli:</strong> 2FA etkinleştirildikten sonra giriş yaparken her seferinde
          authenticator uygulamanızdaki kodu girmeniz gerekecektir. Uygulamayı kaybederseniz
          hesabınıza erişiminiz zorlaşabilir.
        </div>
      </div>
    </Layout>
  );
};

export default TwoFA;
